import axios from "axios";
import dayjs from "dayjs";

import { Grid } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/EditOutlined";

import { useDialog } from "src/context/DialogContext";
import { useAuth } from "src/hooks/useAuth";
import { Primary } from "src/styles/color";
import font from "src/styles/font";

import Button from "src/components/core/Button";
import ButtonDownloadFile from "src/components/core/ButtonDownloadFile";
// import ButtonUploadFile from "src/components/core/ButtonUploadFile";

import InvDialog from "src/modules/order/shipping-order/modal/InvDialog";
import PoDialog from "src/modules/order/shipping-order/modal/PoDialog";
import QtDialog from "src/modules/order/shipping-order/modal/QtDialog";
import VcDialog from "src/modules/order/shipping-order/modal/VcDialog";
import {
  Desc,
  InfoDoc,
  Line,
  Title,
  WrapEdit,
} from "src/modules/order/shipping-order/components";

const DocumentInfo = ({ info, isCloseDialog, setIsLoading }) => {
  const { user, checkAllowPermission } = useAuth();
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const isSeller = user?.role_id === 3;

  const handleDocument = ({ type, mode, owner }) => {
    switch (type) {
      case "qt":
        openDialog({
          type: "custom",
          customDialog: (
            <QtDialog
              orderDetail={info}
              setIsLoading={setIsLoading}
              mode={mode}
              onClose={() => closeDialog()}
              onSuccess={() => {
                closeAllDialogs();
                isCloseDialog();
              }}
            />
          ),
        });
        break;
      case "inv":
        openDialog({
          type: "custom",
          customDialog: (
            <InvDialog
              orderDetail={info}
              setIsLoading={setIsLoading}
              mode={mode}
              owner={owner}
              onClose={() => closeDialog()}
              onSuccess={() => {
                closeAllDialogs();
                isCloseDialog();
              }}
            />
          ),
        });
        break;
      case "po":
        openDialog({
          type: "custom",
          customDialog: (
            <PoDialog
              orderDetail={info}
              setIsLoading={setIsLoading}
              mode={mode}
              onClose={() => closeDialog()}
              onSuccess={() => {
                closeAllDialogs();
                isCloseDialog();
              }}
            />
          ),
        });
        break;
      case "vc":
        openDialog({
          type: "custom",
          customDialog: (
            <VcDialog
              orderDetail={info}
              setIsLoading={setIsLoading}
              mode={mode}
              onClose={() => closeDialog()}
              onSuccess={() => {
                closeAllDialogs();
                isCloseDialog();
              }}
            />
          ),
        });
        break;

      default:
        break;
    }
  };

  const handleDownload = async ({ type, pos, owner }) => {
    const fileUrl = info.documents[owner][type][pos].docUrl;
    const fileName = `${info.documents[owner][type][pos].originalFileName}.${info.documents[owner][type][pos].objectKey.split(".").pop()}`;

    try {
      const response = await axios.get(fileUrl, { responseType: "blob" });
      const blob = new Blob([response.data]);
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName); // ชื่อไฟล์ที่ต้องการให้ดาวน์โหลด
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl); // ล้าง URL Blob หลังดาวน์โหลด
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Grid container>
      {!isSeller && (
        <>
          <Grid container xs={12} sx={{ mb: { xs: 2, sm: 2, md: 2, lg: 3 } }}>
            <Grid item xs={12}>
              <Title>เอกสารสำหรับลูกค้า</Title>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              sx={{ pr: { xs: 0, sm: 1.5 } }}
            >
              <Grid item xs={12} display="flex" alignItems="flex-end">
                <Desc>ใบเสนอราคา</Desc>
              </Grid>

              {info?.documents?.customer?.qt?.qtFile ||
                (info?.order?.quotationPdf && (
                  <Grid container xs={12} mt={1}>
                    <Grid item xs={6} pr={0.5}>
                      <ButtonDownloadFile
                        name="ใบเสนอราคา"
                        onClick={async () => {
                          const fileUrl =
                            info?.order?.quotationPdf?.docUrl ??
                            info?.documents?.customer?.qt?.qtFile.path;
                          const fileName = `${info?.order?.quotationPdf?.originalFileName}.${info?.order?.quotationPdf?.objectKey.split(".").pop()}`;

                          const response = await axios.get(fileUrl, {
                            responseType: "blob",
                          });
                          const blob = new Blob([response.data]);
                          const blobUrl = URL.createObjectURL(blob);

                          const link = document.createElement("a");
                          link.href = blobUrl;
                          link.setAttribute("download", fileName); // ชื่อไฟล์ที่ต้องการให้ดาวน์โหลด
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);

                          URL.revokeObjectURL(blobUrl); // ล้าง URL Blob หลังดาวน์โหลด
                        }}
                      />
                    </Grid>

                    {(info?.documents?.customer?.qt?.additionalFile ||
                      info?.order?.quotationOtherPdf) && (
                      <Grid item xs={6} pl={0.5}>
                        <ButtonDownloadFile
                          name="เพิ่มเติม"
                          onClick={async () => {
                            const fileUrl =
                              info?.order?.quotationOtherPdf?.docUrl ??
                              info?.documents?.customer?.qt?.qtFile.path;
                            const fileName = `${info?.order?.quotationOtherPdf?.originalFileName}.${info?.order?.quotationOtherPdf?.objectKey.split(".").pop()}`;

                            const response = await axios.get(fileUrl, {
                              responseType: "blob",
                            });
                            const blob = new Blob([response.data]);
                            const blobUrl = URL.createObjectURL(blob);

                            const link = document.createElement("a");
                            link.href = blobUrl;
                            link.setAttribute("download", fileName); // ชื่อไฟล์ที่ต้องการให้ดาวน์โหลด
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            URL.revokeObjectURL(blobUrl); // ล้าง URL Blob หลังดาวน์โหลด
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>
                ))}

              {(info?.documents?.customer?.qt?.qtNo ||
                info?.order?.qtNumber) && (
                <Grid container xs={12} mt={1}>
                  <InfoDoc>{`No. ${info?.documents?.customer?.qt?.qtNo ?? info?.order?.qtNumber}`}</InfoDoc>
                  {info?.order?.quotationPdf?.createdAt && (
                    <InfoDoc
                      isDate
                    >{`(${dayjs(info?.order?.quotationPdf?.createdAt).format("DD-MM-YYYY")})`}</InfoDoc>
                  )}
                </Grid>
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              sx={{ pl: { xs: 0, sm: 1.5 }, mt: { xs: 2, sm: 0 } }}
            >
              <Grid item xs={12} display="flex" alignItems="flex-end">
                <Desc>ใบเสร็จ/ใบกำกับภาษี</Desc>

                {checkAllowPermission("orders.can_update_shippingOrder") &&
                  (info?.documents?.customer?.inv?.customerInvFile ||
                    info?.documents?.customer?.inv
                      ?.customerInvAdditionalFile) && (
                    <WrapEdit
                      onClick={() =>
                        handleDocument({
                          type: "inv",
                          mode: "edit",
                          owner: "customer",
                        })
                      }
                    >
                      <Desc margin="0 5px 0 0" isLink primary>
                        แก้ไข
                      </Desc>
                      <EditIcon
                        sx={{
                          color: Primary,
                          fontSize: font.size.xl,
                        }}
                      />
                    </WrapEdit>
                  )}
              </Grid>

              {info?.documents?.customer?.inv?.customerInvFile ||
              info?.documents?.customer?.inv?.customerInvAdditionalFile ? (
                <Grid container xs={12} mt={1}>
                  {info?.documents?.customer?.inv?.customerInvFile && (
                    <Grid item xs={6} pr={0.5}>
                      <ButtonDownloadFile
                        name="ใบเสร็จ/ใบกำกับภาษี"
                        onClick={() => {
                          handleDownload({
                            type: "inv",
                            pos: "customerInvFile",
                            owner: "customer",
                          });
                        }}
                      />
                    </Grid>
                  )}

                  {info?.documents?.customer?.inv
                    ?.customerInvAdditionalFile && (
                    <Grid
                      item
                      xs={6}
                      pl={
                        info?.documents?.customer?.inv?.customerInvFile && 0.5
                      }
                    >
                      <ButtonDownloadFile
                        name="เพิ่มเติม"
                        onClick={() => {
                          handleDownload({
                            type: "inv",
                            pos: "customerInvAdditionalFile",
                            owner: "customer",
                          });
                        }}
                      />
                    </Grid>
                  )}

                  <Grid container xs={12} mt={1}>
                    {info?.documents?.customer?.inv?.invNo && (
                      <InfoDoc>{`No. ${info?.documents?.customer?.inv?.invNo}`}</InfoDoc>
                    )}

                    {info?.documents?.customer?.inv?.invDate && (
                      <InfoDoc
                        isDate
                      >{`(${dayjs(info?.documents?.customer?.inv?.invDate).format("DD-MM-YYYY")})`}</InfoDoc>
                    )}
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12} mt={1}>
                  <Button
                    className="MuiButton-upload full"
                    startIcon={<AddIcon />}
                    variant="outlined"
                    disabled={
                      !checkAllowPermission("orders.can_update_shippingOrder")
                    }
                    onClick={() =>
                      handleDocument({
                        type: "inv",
                        mode: "add",
                        owner: "customer",
                      })
                    }
                  >
                    อัพโหลดใบเสร็จ/ใบกำกับภาษี
                  </Button>
                  {/* <ButtonUploadFile
                    className="full"
                    name="อัพโหลดใบเสร็จ/ใบกำกับภาษี"
                    onClick={() =>
                      handleDocument({
                        type: "inv",
                        mode: "add",
                        owner: "customer",
                      })
                    }
                  /> */}
                </Grid>
              )}
            </Grid>
          </Grid>

          <Line />

          <Grid container xs={12} sx={{ mb: { xs: 2, sm: 2, md: 2, lg: 3 } }}>
            <Grid item xs={12}>
              <Title>เอกสารสำหรับ XSF</Title>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              sx={{ pr: { xs: 0, sm: 1.5 }, mb: { xs: 2, sm: 0 } }}
            >
              <Grid item xs={12} display="flex" alignItems="flex-end">
                <Desc>ใบ PO</Desc>

                {checkAllowPermission("orders.can_update_shippingOrder") &&
                  (info?.documents?.xsurface?.po?.xsurfacePoFile ||
                    info?.documents?.xsurface?.po
                      ?.xsurfacePoAdditionalFile) && (
                    <WrapEdit
                      onClick={() =>
                        handleDocument({ type: "po", mode: "edit" })
                      }
                    >
                      <Desc margin="0 5px 0 0" isLink primary>
                        แก้ไข
                      </Desc>
                      <EditIcon
                        sx={{
                          color: Primary,
                          fontSize: font.size.xl,
                        }}
                      />
                    </WrapEdit>
                  )}
              </Grid>

              {info?.documents?.xsurface?.po?.xsurfacePoFile ||
              info?.documents?.xsurface?.po?.xsurfacePoAdditionalFile ? (
                <Grid container xs={12} mt={1}>
                  {info?.documents?.xsurface?.po?.xsurfacePoFile && (
                    <Grid item xs={6} pr={0.5}>
                      <ButtonDownloadFile
                        name="ใบ PO"
                        onClick={() => {
                          handleDownload({
                            type: "po",
                            pos: "xsurfacePoFile",
                            owner: "xsurface",
                          });
                        }}
                      />
                    </Grid>
                  )}

                  {info?.documents?.xsurface?.po?.xsurfacePoAdditionalFile && (
                    <Grid
                      item
                      xs={6}
                      pl={info?.documents?.xsurface?.po?.xsurfacePoFile && 0.5}
                    >
                      <ButtonDownloadFile
                        name="เอกสารใบ PO เพิ่มเติม"
                        onClick={() => {
                          handleDownload({
                            type: "po",
                            pos: "xsurfacePoAdditionalFile",
                            owner: "xsurface",
                          });
                        }}
                      />
                    </Grid>
                  )}

                  <Grid container xs={12} mt={1}>
                    {info?.documents?.xsurface?.po?.poNo && (
                      <InfoDoc>{`No. ${info?.documents?.xsurface?.po?.poNo}`}</InfoDoc>
                    )}

                    {info?.documents?.xsurface?.po?.poDate && (
                      <InfoDoc
                        isDate
                      >{`(${dayjs(info?.documents?.xsurface?.po?.poDate).format("DD-MM-YYYY")})`}</InfoDoc>
                    )}
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12} mt={1}>
                  <Button
                    className="MuiButton-upload full"
                    startIcon={<AddIcon />}
                    variant="outlined"
                    disabled={
                      !checkAllowPermission("orders.can_update_shippingOrder")
                    }
                    onClick={() => handleDocument({ type: "po", mode: "add" })}
                  >
                    อัพโหลดใบ PO
                  </Button>
                  {/* <ButtonUploadFile
                    className="full"
                    name="อัพโหลดใบ PO"
                    disabled={
                      !checkAllowPermission("orders.can_update_shippingOrder")
                    }
                    onClick={() => handleDocument({ type: "po", mode: "add" })}
                  /> */}
                </Grid>
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              sx={{ pl: { xs: 0, sm: 1.5 } }}
            >
              <Grid item xs={12} display="flex" alignItems="flex-end">
                <Desc>ใบ VC</Desc>

                {checkAllowPermission("orders.can_update_shippingOrder") &&
                  (info?.documents?.xsurface?.vc?.xsurfaceVcFile ||
                    info?.documents?.xsurface?.vc
                      ?.xsurfaceVcAdditionalFile) && (
                    <WrapEdit
                      onClick={() =>
                        handleDocument({ type: "vc", mode: "edit" })
                      }
                    >
                      <Desc margin="0 5px 0 0" isLink primary>
                        แก้ไข
                      </Desc>
                      <EditIcon
                        sx={{
                          color: Primary,
                          fontSize: font.size.xl,
                        }}
                      />
                    </WrapEdit>
                  )}
              </Grid>

              {info?.documents?.xsurface?.vc?.xsurfaceVcFile ||
              info?.documents?.xsurface?.vc?.xsurfaceVcAdditionalFile ? (
                <Grid container xs={12} mt={1}>
                  {info?.documents?.xsurface?.vc?.xsurfaceVcFile && (
                    <Grid item xs={6} pr={0.5}>
                      <ButtonDownloadFile
                        name="ใบ VC"
                        onClick={() => {
                          handleDownload({
                            type: "vc",
                            pos: "xsurfaceVcFile",
                            owner: "xsurface",
                          });
                        }}
                      />
                    </Grid>
                  )}

                  {info?.documents?.xsurface?.vc?.xsurfaceVcAdditionalFile && (
                    <Grid
                      item
                      xs={6}
                      pl={info?.documents?.xsurface?.vc?.xsurfaceVcFile && 0.5}
                    >
                      <ButtonDownloadFile
                        name="เพิ่มเติม"
                        onClick={() => {
                          handleDownload({
                            type: "vc",
                            pos: "xsurfaceVcAdditionalFile",
                            owner: "xsurface",
                          });
                        }}
                      />
                    </Grid>
                  )}

                  <Grid container xs={12} mt={1}>
                    {info?.documents?.xsurface?.vc?.vcNo && (
                      <InfoDoc>{`No. ${info?.documents?.xsurface?.vc?.vcNo}`}</InfoDoc>
                    )}

                    {info?.documents?.xsurface?.vc?.vcDate && (
                      <InfoDoc
                        isDate
                      >{`(${dayjs(info?.documents?.xsurface?.vc?.vcDate).format("DD-MM-YYYY")})`}</InfoDoc>
                    )}
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12} mt={1}>
                  <Button
                    className="MuiButton-upload full"
                    startIcon={<AddIcon />}
                    variant="outlined"
                    disabled={
                      !checkAllowPermission("orders.can_update_shippingOrder")
                    }
                    onClick={() => handleDocument({ type: "vc", mode: "add" })}
                  >
                    อัพโหลดใบ VC
                  </Button>
                  {/* <ButtonUploadFile
                    className="full"
                    name="อัพโหลดใบ VC"
                    disabled={
                      !checkAllowPermission("orders.can_update_shippingOrder")
                    }
                    onClick={() => handleDocument({ type: "vc", mode: "add" })}
                  /> */}
                </Grid>
              )}
            </Grid>
          </Grid>

          <Line />
        </>
      )}

      {/* ใบ PO สำหรับ seller */}
      {isSeller && !!info?.documents?.xsurface?.po?.xsurfacePoFile && (
        <>
          <Grid container xs={12} sx={{ mb: { xs: 2, sm: 2, md: 2, lg: 3 } }}>
            <Grid item xs={12}>
              <Title>เอกสาร XSF</Title>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              sx={{ pr: { xs: 0, sm: 1.5 }, mb: { xs: 2, sm: 0 } }}
            >
              <Grid item xs={12} display="flex" alignItems="flex-end">
                <Desc>ใบ PO</Desc>
              </Grid>

              <Grid container xs={12} mt={1}>
                <Grid item xs={6} pr={0.5}>
                  <ButtonDownloadFile
                    name="ใบ PO"
                    onClick={() => {
                      handleDownload({
                        type: "po",
                        pos: "xsurfacePoFile",
                        owner: "xsurface",
                      });
                    }}
                  />
                </Grid>

                {info?.documents?.xsurface?.po?.xsurfacePoAdditionalFile && (
                  <Grid
                    item
                    xs={6}
                    pl={info?.documents?.xsurface?.po?.xsurfacePoFile && 0.5}
                  >
                    <ButtonDownloadFile
                      name="เพิ่มเติม"
                      onClick={() => {
                        handleDownload({
                          type: "po",
                          pos: "xsurfacePoAdditionalFile",
                          owner: "xsurface",
                        });
                      }}
                    />
                  </Grid>
                )}

                <Grid container xs={12} mt={1}>
                  {info?.documents?.xsurface?.po?.poNo && (
                    <InfoDoc>{`No. ${info?.documents?.xsurface?.po?.poNo}`}</InfoDoc>
                  )}

                  {info?.documents?.xsurface?.po?.poDate && (
                    <InfoDoc
                      isDate
                    >{`(${dayjs(info?.documents?.xsurface?.po?.poDate).format("DD-MM-YYYY")})`}</InfoDoc>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Line />
        </>
      )}

      <Grid container xs={12} sx={{ mb: { xs: 1, sm: 0 } }}>
        <Grid item xs={12}>
          <Title>เอกสารของร้านค้า</Title>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          sx={{ pr: { xs: 0, sm: 1.5 }, mb: { xs: 2, sm: 0 } }}
        >
          <Grid item xs={12} display="flex" alignItems="flex-end">
            <Desc>ใบเสนอราคา</Desc>
            {checkAllowPermission("orders.can_update_shippingOrder") &&
              (info?.documents?.seller?.qt?.sellerQtFile ||
                info?.documents?.seller?.qt?.sellerQtAdditionalFile) && (
                <WrapEdit
                  onClick={() => handleDocument({ type: "qt", mode: "edit" })}
                >
                  <Desc margin="0 5px 0 0" isLink primary>
                    แก้ไข
                  </Desc>
                  <EditIcon
                    sx={{
                      color: Primary,
                      fontSize: font.size.xl,
                    }}
                  />
                </WrapEdit>
              )}
          </Grid>

          {info?.documents?.seller?.qt?.sellerQtFile ||
          info?.documents?.seller?.qt?.sellerQtAdditionalFile ? (
            <Grid container xs={12} mt={1}>
              {info?.documents?.seller?.qt?.sellerQtFile && (
                <Grid item xs={6} pr={0.5}>
                  <ButtonDownloadFile
                    name="ใบเสนอราคา"
                    onClick={() => {
                      handleDownload({
                        type: "qt",
                        pos: "sellerQtFile",
                        owner: "seller",
                      });
                    }}
                  />
                </Grid>
              )}

              {info?.documents?.seller?.qt?.sellerQtAdditionalFile && (
                <Grid
                  item
                  xs={6}
                  pl={info?.documents?.seller?.qt?.sellerQtFile && 0.5}
                >
                  <ButtonDownloadFile
                    name="เพิ่มเติม"
                    onClick={() => {
                      handleDownload({
                        type: "qt",
                        pos: "sellerQtAdditionalFile",
                        owner: "seller",
                      });
                    }}
                  />
                </Grid>
              )}

              <Grid container xs={12} mt={1}>
                {info?.documents?.seller?.qt?.qtNo && (
                  <InfoDoc>{`No. ${info?.documents?.seller?.qt?.qtNo}`}</InfoDoc>
                )}

                {info?.documents?.seller?.qt?.qtDate && (
                  <InfoDoc
                    isDate
                  >{`(${dayjs(info?.documents?.seller?.qt?.qtDate).format("DD-MM-YYYY")})`}</InfoDoc>
                  // <InfoDoc
                  //   isDate
                  // >{`(${dayjs(info?.documents?.seller?.qt?.qtDate ?? info?.documents?.seller?.qt?.qtFile?.createdAt).format("DD-MM-YYYY")})`}</InfoDoc>
                )}
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={12} mt={1}>
              <Button
                className="MuiButton-upload full"
                startIcon={<AddIcon />}
                variant="outlined"
                disabled={
                  !checkAllowPermission("orders.can_update_shippingOrder")
                }
                onClick={() =>
                  handleDocument({
                    type: "qt",
                    mode: "add",
                    // owner: "seller",
                  })
                }
              >
                อัพโหลดใบเสนอราคา
              </Button>
              {/* <ButtonUploadFile
                className="full"
                name="อัพโหลดใบเสนอราคา"
                disabled={
                  !checkAllowPermission("orders.can_update_shippingOrder")
                }
                onClick={() =>
                  handleDocument({
                    type: "qt",
                    mode: "add",
                    // owner: "seller",
                  })
                }
              /> */}
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ pl: { xs: 0, sm: 1.5 } }}>
          <Grid item xs={12} display="flex" alignItems="flex-end">
            <Desc>ใบเสร็จ/ใบกำกับภาษี</Desc>

            {checkAllowPermission("orders.can_update_shippingOrder") &&
              (info?.documents?.seller?.inv?.sellerInvFile ||
                info?.documents?.seller?.inv?.sellerInvAdditionalFile) && (
                <WrapEdit
                  onClick={() =>
                    handleDocument({
                      type: "inv",
                      mode: "edit",
                      owner: "seller",
                    })
                  }
                >
                  <Desc margin="0 5px 0 0" isLink primary>
                    แก้ไข
                  </Desc>
                  <EditIcon
                    sx={{
                      color: Primary,
                      fontSize: font.size.xl,
                    }}
                  />
                </WrapEdit>
              )}
          </Grid>

          {info?.documents?.seller?.inv?.sellerInvFile ||
          info?.documents?.seller?.inv?.sellerInvAdditionalFile ? (
            <Grid container xs={12} mt={1}>
              {info?.documents?.seller?.inv?.sellerInvFile && (
                <Grid item xs={6} pr={0.5}>
                  <ButtonDownloadFile
                    name="ใบเสร็จ/ใบกำกับภาษี"
                    onClick={() => {
                      handleDownload({
                        type: "inv",
                        pos: "sellerInvFile",
                        owner: "seller",
                      });
                    }}
                  />
                </Grid>
              )}

              {info?.documents?.seller?.inv?.sellerInvAdditionalFile && (
                <Grid
                  item
                  xs={6}
                  pl={info?.documents?.seller?.inv?.sellerInvFile && 0.5}
                >
                  <ButtonDownloadFile
                    name="เพิ่มเติม"
                    onClick={() => {
                      handleDownload({
                        type: "inv",
                        pos: "sellerInvAdditionalFile",
                        owner: "seller",
                      });
                    }}
                  />
                </Grid>
              )}

              <Grid container xs={12} mt={1}>
                {info?.documents?.seller?.inv?.invNo && (
                  <InfoDoc>{`No. ${info?.documents?.seller?.inv?.invNo}`}</InfoDoc>
                )}

                {info?.documents?.seller?.inv?.invDate && (
                  <InfoDoc
                    isDate
                  >{`(${dayjs(info?.documents?.seller?.inv?.invDate).format("DD-MM-YYYY")})`}</InfoDoc>
                )}
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={12} mt={1}>
              <Button
                className="MuiButton-upload full"
                startIcon={<AddIcon />}
                variant="outlined"
                disabled={
                  !checkAllowPermission("orders.can_update_shippingOrder")
                }
                onClick={() =>
                  handleDocument({ type: "inv", mode: "add", owner: "seller" })
                }
              >
                อัพโหลดใบเสร็จ/ใบกำกับภาษี
              </Button>
              {/* <ButtonUploadFile
                className="full"
                name="อัพโหลดใบเสร็จ/ใบกำกับภาษี"
                disabled={
                  !checkAllowPermission("orders.can_update_shippingOrder")
                }
                onClick={() =>
                  handleDocument({ type: "inv", mode: "add", owner: "seller" })
                }
              /> */}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DocumentInfo;
